"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _TranslationProvider = require("../../TranslationProvider");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useTranslation = function useTranslation() {
  return (0, _react.useContext)(_TranslationProvider.TranslationContext);
};

__signature__(useTranslation, "useContext{}");

var _default = useTranslation;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useTranslation, "useTranslation", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/TranslationProvider/useTranslation.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/TranslationProvider/useTranslation.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSGVhZGVyL1RyYW5zbGF0aW9uUHJvdmlkZXIvdXNlVHJhbnNsYXRpb24udHMiXSwibmFtZXMiOlsidXNlVHJhbnNsYXRpb24iLCJUcmFuc2xhdGlvbkNvbnRleHQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFHQTs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxjQUFjLEdBQUcsU0FBakJBLGNBQWlCLEdBQU07QUFDM0IsU0FBTyx1QkFBV0MsdUNBQVgsQ0FBUDtBQUNELENBRkQ7O2NBQU1ELGM7O2VBSVNBLGM7Ozs7Ozs7Ozs7OzswQkFKVEEsYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IFRyYW5zbGF0aW9ucyB9IGZyb20gJy4nO1xuaW1wb3J0IHsgVHJhbnNsYXRpb25Db250ZXh0LCBUcmFuc2xhdGlvbkZ1bmN0aW9uIH0gZnJvbSAnLi4vLi4vVHJhbnNsYXRpb25Qcm92aWRlcic7XG5cbmNvbnN0IHVzZVRyYW5zbGF0aW9uID0gKCkgPT4ge1xuICByZXR1cm4gdXNlQ29udGV4dChUcmFuc2xhdGlvbkNvbnRleHQpIGFzIFRyYW5zbGF0aW9uRnVuY3Rpb248VHJhbnNsYXRpb25zPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IHVzZVRyYW5zbGF0aW9uO1xuIl19